import {keymap} from '@codemirror/view';
import {deleteMarkupBackward, insertNewlineContinueMarkup} from '@codemirror/lang-markdown';
import {acceptCompletion, closeCompletion, moveCompletionSelection, startCompletion} from '@codemirror/autocomplete';
import {
  cursorLineDown,
  cursorLineUp,
  indentLess,
  indentMore,
  insertNewlineAndIndent,
  moveLineDown,
  moveLineUp,
  redo,
  selectAll,
  selectLine,
  selectLineDown,
  selectLineUp,
  standardKeymap,
  undo
} from '@codemirror/commands';

import {formatBold, formatItalics, formatStrikeThrough, formatUnderline} from '../commands/format.js';
import {insertCodeBlockIgnoreCodeInfo} from "../commands/insertCodeBlock.js";
import {insertKeyNotation} from "../commands/insertKeyNotation.js";
import {leaveKeyboard} from "../commands/leaveKeyboard.js";
import {deleteEmojiBackward} from "../commands/deleteEmojiBackward.js";

const autoComplete = [
  {key: 'Enter', run: acceptCompletion},
  {key: 'Tab', run: acceptCompletion},
  {key: 'Ctrl-Space', run: startCompletion},
  {key: 'ArrowUp', run: moveCompletionSelection(false)},
  {key: 'ArrowDown', run: moveCompletionSelection(true)},
  {key: 'Escape', run: closeCompletion},
];

const markdown = [
  {key: "Enter", run: insertNewlineContinueMarkup},
  {key: "Enter", run: insertNewlineAndIndent},
  {key: "Mod-Backspace", run: deleteEmojiBackward},
  {key: "Backspace", run: deleteMarkupBackward},
];

const history = [
  {key: 'Ctrl-z', run: undo, shift: redo, preventDefault: true},
  {key: 'Ctrl-y', run: redo, preventDefault: true},
];

// We must have these shortcuts handled by the CodeMirror,
// not the browser or node environment
const selection = [
  {key: 'Ctrl-a', mac: 'Cmd-a', run: selectAll},
  {key: 'Alt-l', mac: 'Ctrl-l', run: selectLine},
  {key: 'Tab', run: leaveKeyboard},
];

const codeOperations = [
  {key: 'Tab', run: indentMore, shift: indentLess},
  {win: 'Alt-ArrowRight', linux: 'Alt-ArrowRight', mac: 'Cmd-]', run: indentMore},
  {win: 'Alt-ArrowLeft', linux: 'Alt-ArrowLeft', mac: 'Cmd-[', run: indentLess},
  {key: 'Alt-ArrowUp', run: moveLineUp},
  {key: 'Alt-ArrowDown', run: moveLineDown},
];

const cursor = [
  {key: "ArrowUp", run: cursorLineUp, shift: selectLineUp, preventDefault: true},
  {key: "ArrowDown", run: cursorLineDown, shift: selectLineDown, preventDefault: true},
];

const formatting = [
  {key: 'Ctrl-b', run: formatBold, preventDefault: true},
  {key: 'Ctrl-i', run: formatItalics, preventDefault: true},
  {key: 'Ctrl-s', run: formatStrikeThrough, preventDefault: true},
  {key: 'Ctrl-u', run: formatUnderline, preventDefault: true},
  {key: 'Alt-k', run: insertKeyNotation(''), preventDefault: true},
  {key: 'Ctrl-`', run: insertCodeBlockIgnoreCodeInfo, preventDefault: true},
];

const control = (onSubmit, onCancel) => [
  {key: 'Mod-Enter', run: onSubmit},
  {key: 'Escape', run: onCancel},
];

export default (onSubmit, onCancel) => keymap.of([
  ...autoComplete,
  ...markdown,
  ...history,
  ...selection,
  ...codeOperations,
  ...cursor,
  ...formatting,
  ...control(onSubmit, onCancel),
  ...standardKeymap
]);
